import React from 'react'
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { regEx } from '../../../../resources/Utils';

const CustomerInfo = ({ isEPayment, customerInfo, onChange, disableByMerchantInfo, disableByCustomerInfo, onClickFindCustomer, identification, action }) => {
    return (
        <React.Fragment>
            <Row className="mt-5">
                <Col sm={12} className="font-weight-bold">
                    Customer Information
                </Col>
            </Row>
            <Row className="my-3">
                <Col sm={12}>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="citizenId">
                                <Form.Label className={"text-grey font-weight-bold medium "}>Citizen ID</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        name="citizenId" type="text" placeholder="Enter citizen ID"
                                        pattern="\d{13}"
                                        maxLength="13"
                                        title="Citizen ID must be 13 digits only"
                                        value={identification?.citizenId.value}
                                        onChange={(e) => onChange('citizenId', e.target.name, e.target.value, "NUMERIC")}
                                        disabled={disableByMerchantInfo || action !== 'create' || identification?.citizenId.isExisted}
                                        form="customerFindingForm"
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="fullName">
                                <Form.Label className="text-grey font-weight-bold medium">Full Name</Form.Label>
                                <Form.Control
                                    name="fullName" type="text"
                                    placeholder="Enter full name"
                                    disabled={true}
                                    onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                    value={customerInfo ? customerInfo.fullName : ''}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="passportNumber">
                                <Form.Label className={"text-grey font-weight-bold medium "}>Passport Number</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        name="passportNumber" type="text" placeholder="Enter passport Number"
                                        value={identification?.passportNumber.value}
                                        onChange={(e) => onChange('passportNumber', e.target.name, e.target.value)}
                                        disabled={disableByMerchantInfo || action !== 'create' || identification?.passportNumber.isExisted}
                                        form="customerFindingForm"
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="email">
                                <Form.Label className={"text-grey font-weight-bold medium " + (isEPayment ? "required" : "")}>Email Address</Form.Label>
                                <Form.Control
                                    name="email" type="text"
                                    placeholder="Enter email address"
                                    pattern={regEx.EMAIL}
                                    title="Email is invalid format"
                                    disabled={disableByCustomerInfo}
                                    onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                    value={customerInfo ? customerInfo.email : ''}
                                    required={isEPayment}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="alienId">
                                <Form.Label className={"text-grey font-weight-bold medium "}>Alien ID</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        name="alienId" type="text" placeholder="Enter alien ID"
                                        value={identification?.alienId.value}
                                        onChange={(e) => onChange('alienId', e.target.name, e.target.value)}
                                        disabled={disableByMerchantInfo || action !== 'create' || identification?.alienId.isExisted}
                                        form="customerFindingForm"
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="contactNumber">
                                <Form.Label className="text-grey font-weight-bold medium">Phone Number</Form.Label>
                                <Form.Control
                                    name="contactNumber" type="text"
                                    placeholder="Enter phone number"
                                    maxLength={10}
                                    pattern={regEx.DECIMAL}
                                    title="Phone Number should be 10 digits"
                                    disabled={disableByCustomerInfo}
                                    onChange={(e) => onChange('customerInfo', e.target.name, e.target.value, "NUMERIC")}
                                    value={customerInfo ? customerInfo.contactNumber : ''}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default CustomerInfo
